const userActivityList = {
    userActivity: 'userActivity',
  };
  
  export default userActivityList;
  